import request from '@/utils/request'
import { GetSlsInventoryStatusReq, SlsInventoryStatus } from './types'

export const SLS_INVENTORY_STATUS_URL = '/api/v1/inventory/statuses/sls'

/**
 * SLS 실시간 재고 조회. (LOGISPRD-12146)
 *
 * 응답이 왔다는 것 자체가 대상 센터 **전부**의 SLS 조회 성공을 뜻한다 — BE 가 부분 성공을 만들지 않고
 * 한 센터라도 실패하면 예외로 올린다. 그래서 화면은 실패를 값이 아니라 에러로만 만난다.
 */
export const getSlsInventoryStatus = (params: GetSlsInventoryStatusReq) =>
  request.get<ApiResponseV2<SlsInventoryStatus>, GetSlsInventoryStatusReq>(SLS_INVENTORY_STATUS_URL, params)
